import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/service/authentication.service';

@Component({
  selector: 'app-errorspage',
  templateUrl: './errorspage.component.html',
  styleUrls: ['./errorspage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ErrorspageComponent implements OnInit {

  code: any;
  constructor(private router: Router, private elementRef: ElementRef, private route: ActivatedRoute, private authService: AuthenticationService) {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#fff';
  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.code = params['code'];
      console.log('Error Code:', this.code);
    });

  }
  clearData() {
    this.router.navigate(["/login"]).then((res) => {
      // localStorage.clear();
      this.authService.clearSafeLocalStorage();
    });
  }

  //Admin Widget
  isToggleAdminFlagOpen: boolean = false;
  toggleAdminFlag: boolean = false;
  toggleAdminWidget() {
    this.toggleAdminFlag = !this.toggleAdminFlag;
  }
}
